import { LayoutConfig, LayoutColumn, RowPreset } from "./types";
import { createColumn, createRow, generateId } from "./layoutUtils";

export const DEFAULT_LAYOUT: LayoutConfig = {
  rows: [
    createRow([
      {
        ...createColumn({ value: 1, unit: "fr" }),
        sections: [{ type: "course-hero", content: { showBreadcrumbs: true, showTitle: true } }],
      },
    ]),
    createRow(
      [
        {
          ...createColumn({ value: 2, unit: "fr" }),
          sections: [
            { type: "course-enrollment", content: { variant: "mobile-inline" } },
            {
              type: "course-tabs",
              content: {
                tabs: [
                  { kind: "cards", id: "cards", label: "Informacje", cards: [] },
                  { kind: "built-in", id: "trainers", label: "Wykładowcy" },
                  { kind: "built-in", id: "schedule", label: "Harmonogram" },
                  { kind: "built-in", id: "program", label: "Program" },
                  { kind: "built-in", id: "detailed-info", label: "Szczegóły" },
                  { kind: "built-in", id: "faq", label: "FAQ" },
                ],
                variant: "scroll",
                showSectionHeaders: true,
              },
            },
          ],
        },
        {
          ...createColumn({ value: 1, unit: "fr" }),
          mobileConfig: { visible: false },
          sections: [{ type: "course-enrollment", content: { variant: "desktop-sidebar" } }],
        },
      ],
      24,
    ),
    createRow([
      {
        ...createColumn({ value: 1, unit: "fr" }),
        sections: [{ type: "course-sticky-bar", content: {} }],
      },
    ]),
  ],
};

export const ROW_PRESETS: RowPreset[] = [
  {
    label: "1 kolumna",
    columns: [{ width: { value: 1, unit: "fr" } }],
  },
  {
    label: "2 kolumny (50/50)",
    columns: [
      { width: { value: 1, unit: "fr" } },
      { width: { value: 1, unit: "fr" } },
    ],
  },
  {
    label: "Sidebar (prawy)",
    columns: [
      { width: { value: 2, unit: "fr" } },
      { width: { value: 1, unit: "fr" } },
    ],
  },
  {
    label: "Sidebar (lewy)",
    columns: [
      { width: { value: 1, unit: "fr" } },
      { width: { value: 2, unit: "fr" } },
    ],
  },
  {
    label: "3 kolumny",
    columns: [
      { width: { value: 1, unit: "fr" } },
      { width: { value: 1, unit: "fr" } },
      { width: { value: 1, unit: "fr" } },
    ],
  },
];

export const createRowFromPreset = (preset: RowPreset) => {
  const columns: LayoutColumn[] = preset.columns.map((col) => createColumn(col.width));
  return createRow(columns);
};
